import { useAppDispatch, useAppSelector } from "app.hook";
import * as React from "react";
import { shallowEqual } from "react-redux";
import { selectGuestCustomerInfo, updateGuestCustomerInfo } from "states/shopping-cart/shopping-cart.slice";
export const GuestCustomerInformation = () => {
  const guestCustomerInfo = useAppSelector(selectGuestCustomerInfo, shallowEqual);
  const dispatch = useAppDispatch();
  return (
    <div className="section-container mb-4 rounded-md bg-white p-4">
      <div className="head flex mb-2 justify-between content-center items-center">
        <div className="name font-semibold text-md uppercase">
          Customer Information
        </div>
      </div>
      <div className="order-info mt-4">
        <div className="grid grid-cols-2 sm:grid-cols-1 gap-4 mb-4">
          <div className="form-group mb-0">
            <label htmlFor="firstName" className="mb-1">First Name: </label>
            <input
              id="firstName"
              value={guestCustomerInfo.firstName}
              placeholder="Please enter first name"
              aria-label="First Name"
              aria-placeholder="Please enter first name"
              className="rounded-none px-4 py-4 w-full border border-solid border-gray-300"
              onChange={(ev) => {
                dispatch(updateGuestCustomerInfo({ ...guestCustomerInfo, firstName: ev.target.value }))
              }}
            />
          </div>
          <div className="form-group mb-0">
            <label htmlFor="lastName" className="mb-1">Last Name: </label>
            <input
              id="lastName"
              value={guestCustomerInfo.lastName}
              placeholder="Please enter last name"
              aria-label="Last Name"
              aria-placeholder="Please enter last name"
              className="rounded-none px-4 py-4 w-full border border-solid border-gray-300"
              onChange={(ev) => {
                dispatch(updateGuestCustomerInfo({ ...guestCustomerInfo, lastName: ev.target.value }))
              }}
            />
          </div>
          <div className="form-group mb-0">
            <label htmlFor="email" className="mb-1">Email: </label>
            <input
              id="email"
              value={guestCustomerInfo.email}
              placeholder="Please enter email"
              aria-label="Last Name"
              aria-placeholder="Please enter email"
              className="rounded-none px-4 py-4 w-full border border-solid border-gray-300"
              onChange={(ev) => {
                dispatch(updateGuestCustomerInfo({ ...guestCustomerInfo, email: ev.target.value }))
              }}
            />
          </div>
          <div className="form-group mb-0">
            <label htmlFor="phoneNumber" className="mb-1">Phone Number:</label>
            <input
              id="phoneNumber"
              value={guestCustomerInfo.phoneNumber}
              aria-label="Phone Number"
              placeholder="Please enter phone Number"
              aria-placeholder="Please enter phone Number"
              className="rounded-none px-4 py-4 w-full border border-solid border-gray-300"
              onChange={(ev) => {
                dispatch(updateGuestCustomerInfo({ ...guestCustomerInfo, phoneNumber: ev.target.value }))
              }}
            />
          </div>
        </div>
        <div className="form-group mb-0">
            <label htmlFor="postalCode" className="mb-1">Postal Code:</label>
            <input
              id="postalCode"
              value={guestCustomerInfo.postalCode}
              aria-label="Postal Code"
              placeholder="Please enter postal code"
              aria-placeholder="Please enter postal code"
              className="rounded-none px-4 py-4 w-full border border-solid border-gray-300"
              onChange={(ev) => {
                dispatch(updateGuestCustomerInfo({ ...guestCustomerInfo, postalCode: ev.target.value }))
              }}
            />
          </div>
      </div>
    </div>
  );
};
